import {
  Stack,
  Typography
} from '@mui/material';
import React, { ReactNode } from 'react';



export type WeatherMetricProps = {
  icon?: ReactNode;
  title: string;
  subTitle: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: WeatherMetricProps) => {

  return (
    <Stack
      paddingX='2rem'
      direction='column'
    >
      <Stack
        justifyContent='center'
        direction='row'
        columnGap='.62rem'
      >
        {props.icon && (
          props.icon
        )}

        <Typography
          variant='modalTitle'
        >
          {props.title}
        </Typography>
      </Stack>
      <Typography
        variant='modalSubTitle'
      >
        {props.subTitle}
      </Typography>
    </Stack>
  );
};
